export const API_SERVER = "https://app.everpayinc.com:5000/api/";
